import config from "../config/index";
import ajax from './axios.config';

// 全局构造函数
// 应用方法 new Date(里面写时间).fromat("yyyy-MM-dd")
Date.prototype.format = function (fmt) {
    var o = {
        "y+": this.getFullYear(), //年份
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

/**
 * 字符串截取后面加入...
 *
 * @author ADCannon
 * @date 2021/07/16
 * @param {Number} len 指定开始截取的长度
 * @return {*} 截取后的字符串
 */
String.prototype.interceptString = function (len) {
    if (this.length > len) {
        return this.substring(0, len) + "...";
    } else {
        return this;
    }
}

/**
 * 将一个字符串用给定的字符变成数组
 *
 * @author ADCannon
 * @date 2021/07/16
 * @param {String} tag 指定的字符串
 * @return {Array} 处理后的数组
 */
String.prototype.toArray = function (tag) {
    if (this.indexOf(tag) != -1) {
        return this.split(tag);
    } else {
        if (this != '') {
            return [this.toString()];
        } else {
            return [];
        }
    }
}

/**
 * 数组对象排序
 *
 * @author ADCannon
 * @date 2021/07/16
 * @param {string} [rule='ASC'] ASC正序  DESC倒序 默认正序排序
 * @param {string} [key=""] 需要排序的key，如不需要可不传或传""
 * @return {Array} 返回排序后的数组
 */
Array.prototype.arrSort = function (rule = 'ASC', key = "") {
    if (this.length > 0) {
        this.sort((x, y) => {
            switch (rule) {
                case "ASC":
                    if (key != "") {
                        return x[key] - y[key];
                    } else {
                        return x - y;
                    }
                case "DESC":
                    if (key != "") {
                        return y[key] - x[key];
                    } else {
                        return y - x;
                    }

                default:
                    return;
            }
        });
        return this;
    } else {
        return this;
    }
}

window.newWindowClick = true;

const utils = {
    /**
     * @description: 本地存储相关
     * @author: ADCannon
     * @date: 2021-07-16 11:54:31
     * @version: V1.0.0
     */
    storage: {
        get: function (str) {
            let Getitem = localStorage.getItem(str);
            try {
                if (Getitem) {
                    if (JSON.parse(Getitem).data) {
                        return JSON.parse(Getitem).data;
                    } else {
                        return JSON.parse(Getitem)
                    }
                } else {
                    return null;
                }
            } catch (error) {
                return null;
            }

        },
        set: function (str, data) {
            localStorage.setItem(str, JSON.stringify(data))
        },
        remove: function (str) {
            localStorage.removeItem(str);
        }
    },

    /**
     * @description: 获取与设置cookie
     * @author: ADCannon
     * @date: 2021-07-16 11:54:43
     * @version: V1.0.0
     */
    cookie: function (key, value, options) {
        // 未传递 value 参数，则表示读取 cookie
        if (typeof value === "undefined") {
            // 将域下所有 cookie 读取出来，以 "; " 分割保存到数组中
            var cookies = document.cookie.split("; ");
            // 遍历迭代所有的 cookie ，查找指定 key 对应的 cookie 值
            for (var i = 0, len = cookies.length; i < len; i++) {
                // 将当前遍历到的 cookie 使用 "=" 分割
                var parts = cookies[i].split("=");
                // 数组中第一个元素为 cookie 名，将 cookie 名解码
                var name = decodeURIComponent(parts.shift());
                // 判断当前 cookie 名与待查找 cookie 的名称是否一致
                if (name === key) // 找到 cookie，则返回对应 cookie 值
                    return decodeURIComponent(parts.join("="));
            }

            // 如果循环迭代完毕所有 cookie 都不存在要查找的 cookie 信息，则说明未保存过
            return undefined;
        }

        // 传递了 value 参数，表示保存 cookie
        // "key=value"，将 key 和 value 编码
        var _cookie = encodeURIComponent(key) + "=" + encodeURIComponent(value);
        // 判断可配置选项
        options = options || {};
        if (options.expires) { // 有失效时间的配置
            var date = new Date();
            date.setDate(date.getDate() + options.expires);
            _cookie += ";expires=" + date.toUTCString();
        }
        if (options.path) // 有配置路径
            _cookie += ";path=" + options.path;
        if (options.domain) // 域
            _cookie += ";domain=" + options.domain;
        if (options.secure) // 安全链接
            _cookie += ";secure";
        // 保存 cookie
        document.cookie = _cookie;
    },
    /**
     * @description: 删除cookie
     * @author: ADCannon
     * @date: 2021-07-16 11:54:55
     * @version: V1.0.0
     */
    removeCookie(key, options) {
        options = options || {};
        options.expires = -1;
        cookie(key, "", options);
    },
    // 浏览器UA判断相关
    browser: {
        /**
         * @description: 是否移动端
         * @author: ADCannon
         * @date: 2021-07-16 11:55:16
         * @version: V1.0.0
         */
        IsMobile: function () {
            let info = navigator.userAgent;
            let agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod", "iPad"];
            for (let i = 0; i < agents.length; i++) {
                if (info.indexOf(agents[i]) >= 0) return true;
            }
            return false;
        },
        /**
         * @description: 是否微信内打开
         * @author: ADCannon
         * @date: 2021-07-16 11:55:35
         * @version: V1.0.0
         */
        isWeiXin: function () {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @description: 是否支付宝内打开
         * @author: ADCannon
         * @date: 2021-07-16 11:55:53
         * @version: V1.0.0
         */
        isAlipay: function () {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/Alipay/i) == "alipay") {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @description: 是否iOS系统
         * @author: ADCannon
         * @date: 2021-07-16 11:58:12
         * @version: V1.0.0
         */
        isiOS: function () {
            var u = navigator.userAgent;
            return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        },
        /**
         * @description: 是否Android系统
         * @author: ADCannon
         * @date: 2021-07-16 11:58:12
         * @version: V1.0.0
         */
        isAndroid: function () {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
            return isAndroid;
        }
    },
    urlParam(url, params) {
        let keys = Object.keys(params)
        let strArr = url.split('/')
        let result = ''
        strArr.forEach(i => {
            if (i[0] === ':') {
                keys.forEach(j => {
                    if (j === i.substring(1, i.length)) {
                        i = params[j].toString()
                    }
                })
            }
            result += i + '/'
        })
        return result.substring(0, result.length - 1)
    },
    creatApi(options) {
        let _this = this;
        let result = {};
        let funNames = Object.keys(options);
        funNames.forEach(name => {
            result[name] = obj => {
                const method = options[name][0];
                let url = options[name][1];
                if (obj) {
                    url = this.urlParam(url, obj);
                }
                return ajax[method](url, obj);
            }
        });
        return result;
    },
    /**
     * @description: 获取页面指定参数
     * @author: ADCannon
     * @date: 2021-07-16 11:59:54
     * @version: V1.0.0
     */
    getQueryString: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURIComponent(unescape(r[2]));
        return null;
    },
    /**
     * App内打开新页面跳转
     *
     * @author ADCannon
     * @date 2021/07/16
     * @param {String} Url 需要跳转的Url
     * @param {Object} [param={}] 跳转需要携带的参数
     */
    openWithNewWindow: function (Url, param = {}) {
        if (window.newWindowClick == false) {
            return;
        };
        window.newWindowClick = false;
        let a = document.createElement("a");
        if (Object.keys(param).length > 0) {
            Object.keys(param).forEach(key => {
                Url.indexOf("?") != -1 ? Url += `&${key}=${encodeURIComponent(param[key])}` : Url += `?${key}=${encodeURIComponent(param[key])}`;
            });
        }
        // Url.indexOf("?") != -1 ? Url += "&gsAppFuncOpenWithNewWindow=true" : Url += "?gsAppFuncOpenWithNewWindow=true"
        Url.indexOf("?") != -1 ? Url += "&gsAppOpenWithNewWindow=true" : Url += "?gsAppOpenWithNewWindow=true"
        Url += "&kNoneMoreButton=true&appNavigationBarStyle=kNoneBar";
        a.href = Url;
        a.target = '_blank';
        a.click();
        a.remove();
        setTimeout(() => {
            window.newWindowClick = true;
        }, 500);
        return;
    },
    /**
     * App使用默认浏览器打开
     *
     * @author ADCannon
     * @date 2021/07/16
     * @param {String} Url 需要跳转的Url
     * @param {Object} [param={}] 跳转需要携带的参数
     */
    openWithBrowser: function (Url, param = {}) {
        if (window.newWindowClick == false) {
            return;
        };
        window.newWindowClick = false;
        let a = document.createElement("a");
        if (Object.keys(param).length > 0) {
            Object.keys(param).forEach(key => {
                Url.indexOf("?") != -1 ? Url += `&${key}=${encodeURIComponent(param[key])}` : Url += `?${key}=${encodeURIComponent(param[key])}`;
            });
        }
        Url.indexOf("?") != -1 ? Url += "&gsAppOpenWithBrowser=true" : Url += "?gsAppOpenWithBrowser=true"

        a.target = "_blank";
        a.href = Url;
        a.click();
        a.remove();
        setTimeout(() => {
            window.newWindowClick = true;
        }, 500);
        return;
    },
    /**
     * 正则替换字符串中所有的项
     *
     * @author ADCannon
     * @date 2021/07/16
     * @param {String} str 原始字符串
     * @param {String} oldSep 需要替换的字符串
     * @param {String} newSep 需要替换成的字符串
     * @return {String} 替换后的字符串
     */
    replaceAll: function (str, oldSep, newSep) {
        if (str == "" || str == null || str == undefined) {
            return str;
        }
        var reg = new RegExp(oldSep, "g"); // g,表示全部替换。
        return str.replace(reg, newSep);
    },
    // 判断当前运行环境是否为GSApp内置浏览器
    isInAppWebView() {
        if (config.isApp) return true;
        let _isInAppWebView = 0;
        if (utils.getQueryString("InGSApp")) {
            _isInAppWebView = 5;
        } else if (window.navigator.userAgent != null &&
            window.navigator.userAgent.indexOf("GSApp/") >= 0) {
            _isInAppWebView = 6;
        }
        return _isInAppWebView;
    },
    // 引导下载
    toDownload() {
        if (!utils.isInAppWebView()) {
            let a = document.createElement("a");
            // #23NewYear
            // #23NewYearTest
            a.href = `https://app.gamersky.com/toApp/?url=${encodeURIComponent("#23NewYear")}&iOSUMKey=rCWj4D&androidUMKey=je0Lzq`;
            a.target = '_blank'
            a.click();
            a.remove();
        }
    },
    showPCHeadFoot() {
        // pc端显示通用网站header和footer
        if (!utils.browser.IsMobile()) {
            document.getElementById('QZnav').style.display = 'block';
            let nodes = document.getElementsByClassName('Bot');
            Array.from(nodes).forEach(i => {
                i.style.display = "block"
            })
            let hm = document.createElement('script');
            var _bdhmProtocol = (("https:" == document.location.protocol) ? " https://" : "//");
            hm.src = `${_bdhmProtocol}hm.baidu.com/h.js?dcb5060fba0123ff56d253331f28db6a`;
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        } else {
            document.getElementById('QZnav').style.display = 'none';
            let nodes = document.getElementsByClassName('Bot');
            Array.from(nodes).forEach(i => {
                i.style.display = "none"
            })
            let hm = document.createElement('script');
            hm.src = "https://hm.baidu.com/hm.js?05cb8f99ccf63fba650bfa80746211d7";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        }
    },
    // 获取当前目录（不包含文件名）
    getCurrentUrl() {
        //获得完整url
        let path = document.location.href;
        //获取最后一个‘/’的位置
        let index = path.lastIndexOf('/');
        //截取url保留最后一个‘/’
        let url = path.slice(0, index + 1);
        return url;
    },
    // 判断版本号
    versionStringCompare(preVersion = '', lastVersion = '') {
        var sources = preVersion.split('.');
        var dests = lastVersion.split('.');
        var maxL = Math.max(sources.length, dests.length);
        var result = 0;
        for (let i = 0; i < maxL; i++) {
            let preValue = sources.length > i ? sources[i] : 0;
            let preNum = isNaN(Number(preValue)) ? preValue.charCodeAt() : Number(preValue);
            let lastValue = dests.length > i ? dests[i] : 0;
            let lastNum = isNaN(Number(lastValue)) ? lastValue.charCodeAt() : Number(lastValue);
            if (preNum < lastNum) {
                result = -1;
                break;
            } else if (preNum > lastNum) {
                result = 1;
                break;
            }
        }
        return result;
    },
    // 获取容器高度
    getContainerHeight(col, padding, margin, domwidth, domHeight) {
        let clientWidth = window.innerWidth > 700 ? 700 : window.innerWidth;
        let width = (clientWidth - padding - margin) / col;
        return width * (domHeight / domwidth) + "px";
    },
    // 刷新页面
    resizeUpDate() {
        location.reload();
    },
    // 获取指定时间戳是否今天
    isTimeToUpdateData(date) {
        var now = new Date();
        var updateTime = new Date(date);
        if ((updateTime.getFullYear() != now.getFullYear() ||
            updateTime.getMonth() != now.getMonth() ||
            updateTime.getDate() != now.getDate() ||
            updateTime.getHours() < 8) &&
            now.getHours() >= 8) {
            return true;
        }
        // 强制刷新指定时间前的客户端数据缓存：
        // “2023-06-15 16:00:00”前强制刷新：
        else if (updateTime.getTime() <= 1686816000000) {
            return true;
        } else {
            return false;
        }
    },
    // 获取下次刷新时间
    getNextMonday() {
        var today = new Date();
        var year = today.getFullYear(); //本年 
        var month = today.getMonth() + 1; //本月
        var day = today.getDate(); //本日
        var newDate = new Date(year + "/" + month + "/" + day + " 00:00:00"); //年月日拼接

        var nowTime = newDate.getTime(); //当前的时间戳
        var weekDay = newDate.getDay(); //当前星期 0.1.2.3.4.5.6 【0 = 周日】
        var oneDayTime = 24 * 60 * 60 * 1000; //一天的总ms

        // 当前星期减去天数，如今天为周五，则本周一为周五的时间戳减去4天的时间戳。但周日特殊，周一至周六是周几的到的weekDay就是几，但是周日的到的为0，需特殊处理
        var thisWeekMondayTime = (1 - weekDay) * oneDayTime + nowTime; //本周一的时间戳
        if (weekDay == 0) {
            // weekDay = 0 为周日，此时本周一时间为周日减去6天的时间
            thisWeekMondayTime = nowTime - 6 * oneDayTime
        }
        var thisWeekSundayTime = thisWeekMondayTime + 6 * oneDayTime // 本周日
        var nextMonday = thisWeekSundayTime + oneDayTime;
        return nextMonday;
    },
    // 语言切换
    languageSwitching() {
        let language = utils.storage.get("language") || "zh-TW";

        switch (language) {
            case "zh-TW":
                utils.storage.set("language", "zh-CN");

                break;
            case "zh-CN":
                utils.storage.set("language", "zh-TW");
                break;

            default:
                break;
        }
        console.log(language);
        GSAppJsApi.UI.sendNotification("gs.h5.languageSwitching", "修改语言");
    },
    // 补0
    padZero(num) {
        return num < 10 ? '0' + num : num.toString();
    },
    // 计算两个时间之间的差
    calcStartToEndTimes(start, end) {
        var t1 = new Date(end); //格式正确不需要转换
        var t2 = new Date(start);
        var times = t1.getTime() - t2.getTime();//时间差的毫秒数

        var days = parseInt(times / (24 * 1000 * 3600));//计算相差的天数
        var leave = times % (24 * 3600 * 1000);//计算天数后剩余的毫秒数

        var h = parseInt(leave / (3600 * 1000));//计算小时数

        //计算分钟数
        var h_leave = leave % (3600 * 1000);
        var min = parseInt(h_leave / (60 * 1000));

        //计算秒数
        var min_leave = h_leave % (60 * 1000);
        var sec = parseInt(min_leave / 1000);
        return `${utils.padZero(h)}:${utils.padZero(min)}:${utils.padZero(sec)}`
    },
    numberWithCommas(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    handleNumericThousands(num) {
        let str = String(num);
        str = str.replace(/(\d{1,3})(?=(\d{3})+$)/g, function ($1) {
            return $1 = $1 + ','
        })
        return str;
    },
    // 无畏契约
    reredirectPage() {
        // pc端重定向
        if (!utils.browser.IsMobile()) {
            let url = window.location.href;
            // pc打开app站点
            if (url.indexOf('app.gamersky.com/db/valorantSkin/') != -1) {
                url = 'https://www.gamersky.com/tools/valorantSkin/';
                window.location.href = url;
            }
        }

    },

    // 调用爬虫
    CallCrawler(CurrentAddress, CrawlerAddress, callback) {
        GSAppJsApi.UI.openUrlIn2thWebView(CurrentAddress, CrawlerAddress, ["cmp.osano.com", "riotgames.com",'about:blank'],);
        GSAppJsApi.UI.registerNotificationListener("gamersky.app.crawler.state", (response) => {
            if (typeof callback === 'function') {
                callback(response);
            }
        });
    }
}

export default utils;